import { keyframes, styled } from "styled-components";
import { Button, Container } from "../../global/styles/styles";
import { APP, colors } from "../../global";

const flash = (color) => keyframes`
0% { background: 
    linear-gradient(
        0deg,
        ${color} 0%, 
        rgba(0, 0, 0, 0) 20%, 
        rgba(0, 0, 0, 0) 40%, 
        rgba(0, 0, 0, 0) 60%, 
        rgba(0, 0, 0, 0) 80%, 
        rgba(0, 0, 0, 0) 100%);
    }
20% { background: 
    linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%, 
        ${color} 20%,
        rgba(0, 0, 0, 0) 40%, 
        rgba(0, 0, 0, 0) 60%, 
        rgba(0, 0, 0, 0) 80%, 
        rgba(0, 0, 0, 0) 100%);
    }
40% { background: 
    linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%, 
        rgba(0, 0, 0, 0) 20%,
        ${color} 40%,
         rgba(0, 0, 0, 0) 60%, 
        rgba(0, 0, 0, 0) 80%, 
        rgba(0, 0, 0, 0) 100%);
    }
60% { background: 
    linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%, 
        rgba(0, 0, 0, 0) 20%,
        rgba(0, 0, 0, 0) 40%, 
        ${color} 60%,
        rgba(0, 0, 0, 0) 80%, 
        rgba(0, 0, 0, 0) 100%);
    }
80% { background: 
    linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%, 
        rgba(0, 0, 0, 0) 20%,
 rgba(0, 0, 0, 0) 40%, 
 rgba(0, 0, 0, 0) 60%, 
 ${color} 80%,
        rgba(0, 0, 0, 0) 100%);    }
100% { background: 
    linear-gradient(
        0deg,
        rgba(0, 0, 0, 0) 0%, 
        rgba(0, 0, 0, 0) 20%,
         rgba(0, 0, 0, 0) 40%, 
        rgba(0, 0, 0, 0) 60%, 
        rgba(0, 0, 0, 0) 80%,
        ${color} 100%);
    }
/* 100% { background-color: transparent; } */
`;

const ContainerNumTiles = styled(Container)`
  flex-wrap: wrap;
  gap: 5.5px;
  max-width: 450px;
`;

const GameboardButton = styled(Button)`
  background-color: ${(props) =>
    props.$clicked === true ? props.theme.card : props.theme.background};
  color: ${(props) =>
    props.$clicked === true ? props.theme.lightText : props.theme.title};
  transition: transform 100ms ease-in-out;
  // mobile
  &:active {
    transform: scale(0.95);
  }
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: ${(props) =>
        props.$clicked === true ? colors.HOVERED_GRAY : props.theme.primary};
      color: ${(props) =>
        props.$clicked === true ? props.theme.lightText : props.theme.darkText};
      transform: scale(1.07);
    }
    // web
    &:active {
      transform: scale(0.98);
    }
  }
`;

const ContainerOpTiles = styled(Container)`
  flex-wrap: nowrap;
  gap: 5.5px;
  max-width: 370px;
`;

const ContainerOtherTiles = styled(Container)`
  flex-wrap: nowrap;
  justify-content: space-evenly;
  max-width: 450px;
`;

const ContainerGameboard = styled(Container)`
  gap: ${(props) => (props.$multi ? "2vh" : "20px")};
`;

const ContainerBuzzer = styled(Container)`
  flex-direction: column;
  position: absolute;
  height: 50%;
  width: 95%;
  max-width: 450px;
  min-width: ${APP.MIN_WIDTH - 10}px;
  gap: 5px;
  z-index: 3;
`;

const ContainerFlash = styled(Container)`
  align-items: flex-start;
  flex: 6;
  animation-name: ${(props) =>
    props.$trigger !== 0 ? flash(props.$color) : null};
  animation-duration: 0.15s;
  animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  animation-iteration-count: 1;
`;

export {
  ContainerBuzzer,
  ContainerFlash,
  ContainerGameboard,
  ContainerNumTiles,
  ContainerOpTiles,
  ContainerOtherTiles,
  GameboardButton,
};
